import { NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { findDomainByPath } from "../routes/domains";
import { cn } from "@/lib/utils";

function SubNav({ isAgentSession = false }) {
  const { pathname } = useLocation();
  const activeDomain = findDomainByPath(pathname);

  // DomainNav already hides the Agents entry, but a URL still lands here
  // and would otherwise offer Overview / My token — the latter is the
  // page that would hand an agent its API token.
  if (!activeDomain || (isAgentSession && activeDomain.key === "agents")) {
    return null;
  }
  // A `personOnly` page (Investing's Settings) is left out on the same
  // terms: AppShell passes isAgentSession until /users/me/ says human.
  const entries = activeDomain.subNav.filter((entry) => !(isAgentSession && entry.personOnly));

  return (
    // data-subnav: in light mode the inactive tabs' muted text is a step
    // darker on this strip, so it reads ≥ 4.5:1 (tailwind.css, W21).
    <nav
      aria-label={`${activeDomain.label} pages`}
      data-subnav=""
      className="border-b border-border bg-muted/40 font-sans"
    >
      <ul className="page-container flex list-none flex-wrap items-center gap-1 p-0">
        {entries.map((entry) => (
          <li key={entry.key}>
            {/* Exact match, unless the entry is `nested` (domains.js): then
                its child pages light it too — as "true", not "page", since
                the link isn't the page you're on. */}
            <NavLink
              to={entry.path}
              end={!entry.nested}
              aria-current={pathname === entry.path ? "page" : "true"}
              className={({ isActive }) =>
                cn(
                  "flex min-h-11 items-center whitespace-nowrap border-b-2 px-4 py-2.5 no-underline transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-ring md:min-h-0",
                  isActive
                    ? "border-primary font-semibold text-foreground"
                    : "border-transparent text-muted-foreground",
                )
              }
            >
              {entry.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

SubNav.propTypes = {
  isAgentSession: PropTypes.bool,
};

export default SubNav;
